"use client";

// #499 Feature A: fetch the current client's allowed FL delivery weekdays once,
// for the FL date picker. Defaults to BOTH days ([1,3]) while loading and on any
// error, so a slow/failed fetch never hides a day the client is entitled to.

import { useEffect, useState } from "react";
import {
  FL_DELIVERY_WEEKDAYS,
  normalizeAllowedWeekdays,
  type DeliveryDayRule,
} from "@/lib/delivery/delivery-day-rules";

type DeliveryWeekday = 1 | 3;

export function useAllowedDeliveryWeekdays(): DeliveryWeekday[] {
  const [allowed, setAllowed] = useState<DeliveryWeekday[]>([
    ...FL_DELIVERY_WEEKDAYS,
  ]);

  useEffect(() => {
    let cancelled = false;
    fetch("/api/delivery/available-days", { credentials: "include" })
      .then(async (r) => {
        if (cancelled || !r.ok) return;
        const body = (await r.json()) as { allowedWeekdays?: unknown };
        const next = normalizeAllowedWeekdays(body.allowedWeekdays);
        // Never widen past the FL defaults; an empty set (full pause) is honored.
        if (!cancelled && Array.isArray(body.allowedWeekdays)) setAllowed(next);
      })
      .catch(() => {
        /* keep the both-days default on error */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return allowed;
}

// Re-export the rule type so admin UI can import from one place if desired.
export type { DeliveryDayRule };
